import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SiteMaintenancePage } from './site-maintenance';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [
    SiteMaintenancePage,
  ],
  imports: [
    TranslateModule,
    IonicPageModule.forChild(SiteMaintenancePage),
  ],
})
export class SiteMaintenancePageModule {}



// WEBPACK FOOTER //
// ./src/app/shared/site-maintenance/site-maintenance.module.ts